import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store/store'
import createVuetifyInstance from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-material-design-icons/styles.css'

import Toolbar from './components/core/Toolbar.vue'
import Navigation from './components/core/NavigationDrawer.vue'
import Breadcrumbs from './components/core/Breadcrumbs.vue'

import axios from 'axios'
import Cookies from 'vue-cookies'

import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
// register VueFusionCharts component

Vue.use(VueSweetalert2)
Vue.use(Cookies)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)
Vue.component('toolbar', Toolbar)
Vue.component('navigation', Navigation)
Vue.component('breadcrumbs', Breadcrumbs)

Vue.config.productionTip = false
// axios.defaults.baseURL = ''
axios.defaults.baseURL = process.env.VUE_APP_RUTA_API // 'http://sirh.local/'
createVuetifyInstance().then(vuetify => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})
